import concat from 'lodash/concat';
import keyBy from 'lodash/keyBy';
import flatten from 'lodash/flatten';
import cloneDeep from 'lodash/cloneDeep';
import capitalize from 'lodash/capitalize';

export const flattenApplicationFields = ({ optional, required }) => (
  keyBy(flatten(concat(optional, required)), item => (item ? item.key : undefined))
);

export const updateFlattenedFieldsFromFormData = (flatApplicationFields, newFormData) => {
  // copy the correct number of fields for addresses and representatives in the
  // flattenedApplicatino fields
  if ({}.hasOwnProperty.call(newFormData, 'representatives')) {
    // determine number of representatives in the existing form
    const representativesLength = newFormData.representatives.length;
    for (let idx = 0; idx < representativesLength; idx += 1) {
      const representativeProps = flatApplicationFields.representatives.elements.properties;
      if (idx !== 0) {
        representativeProps.required.push(
          cloneDeep(representativeProps.required[0]),
        );
        representativeProps.optional.push(
          cloneDeep(representativeProps.optional[0]),
        );
      }
      // need to check the length of formData.representatives.addresses
      const addressLength = ({}.hasOwnProperty
        .call(newFormData.representatives[idx], 'addresses'))
        ? newFormData.representatives[idx].addresses.length : 0;
      // get the index of addresses in the nested flatApplicationFields
      const addressesIndex = representativeProps.required[idx].findIndex(
        f => f.key === 'addresses',
      );
      const nestedAddressProps = representativeProps.required[idx][addressesIndex]
        ?.elements?.properties || { required: [] };
      // determine how many nested addresses fields to add if greater than 1
      const flatAppFieldLength = nestedAddressProps.required.length || 1;
      for (let addIdx = flatAppFieldLength; addIdx < addressLength; addIdx += 1) {
        nestedAddressProps.required.push(cloneDeep(nestedAddressProps.required[0]));
        nestedAddressProps.optional.push(cloneDeep(nestedAddressProps.optional[0]));
      }
    }
  }
  if ({}.hasOwnProperty.call(newFormData, 'addresses')) {
    const addressesLength = newFormData.addresses.length;
    for (let addIdx = 1; addIdx < addressesLength; addIdx += 1) {
      // add the right number of addresses
      flatApplicationFields.addresses.elements.properties.required
        .push(flatApplicationFields.addresses.elements.properties.required[0]);
      flatApplicationFields.addresses.elements.properties.optional
        .push(flatApplicationFields.addresses.elements.properties.optional[0]);
    }
  }
  return flatApplicationFields;
};

export const handleStatus = status => {
  switch (status) {
    case 'completed':
      return ['success', 'Success'];
    case 'errored':
      return ['danger', 'Failure'];
    default:
      return ['neutral', capitalize(status)];
  }
};

export const formatSourceName = name => {
  const dictionary = {
    adhoc: 'Ad Hoc',
  };
  return dictionary[name] || capitalize(name);
};

export const handleSource = name => [name, formatSourceName(name)];
